import styled from 'styled-components'

const FinanceSection = styled.div`
  display: grid;
  gap: 20px;
`

export default FinanceSection
